let swipers = {

    manufacturers: {
        slider: false,
        elem: $('.js-manufacturers-slider').eq(0),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 24,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            autoplay: {
                delay: 4500
            },
            pagination: {
                el: $('.js-manufacturers-slider-dots').eq(0),
                clickable: true
            },
            breakpoints: {
                599: {
                    spaceBetween: 15,
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
            },
            on: {
                init: function () {
                    swipers.manufacturers.active = true;
                },
                slideChange: function() {
                    setTimeout(function() {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    },
    infobox3: {
        slider: false,
        elem: $('.js-slider-infobox-3'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            simulateTouch: false,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            pagination: {
                el: '.js-slider-infobox-3-pagination',
                clickable: true
            },
            on: {
                init: function () {
                    swipers.infobox3.active = true;
                },
                slideChange: function() {
                    setTimeout(function() {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    },
};

rEvent.on('Window.resized', function() {
    checkSliders(swipers);
});

$(function() {
    checkSliders(swipers);
});
